import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { formatHeadingText } from '../../util/formatSportHeadingText';

const mapStateToProps = state => ({
  country: state.country,
});

const descriptions = {
  se: {
    startpage: 'Video Höjdpunkter, klipp, sammandrag, mål, nyheter från Champions Leage, Premier League, Seria A, La Liga, Ligue 1, NFL, NHL, Formula 1 och mycket mer. Även statistik tabeller och bloggar.',
    fotboll: 'Se klipp från Champions League, Premier League, Seria A, Laliga, Lague 1 och mycket mer. Följ Zlatans mål och i hans matcher i Manchester Unitied. Messis och Ronaldos framfart i Spanien.',
    ishockey: 'Se sammandrag från samtliga matcher i NHL.',
    motor: 'Följ Markus Erikssons framfart i Formula 1. Se sammandrag och klipp från alla lopp.',
    nfl: 'Se alla video och läsa alla nyheter om NFL.',
    golf: 'Se alla vår video och klipp från våra golfrättigheter. Här följer du bland annat Henrik Strenssons framfart.',
    kampsport: 'Se alla klipp från våra fightingrättigheter så som UFC. Se The Mauler, McGregors och de andra stjärnornas matcher.',
  },
  no: {
    startpage: 'Høydepunkter, mål, nyheter og sendeskjema fra Champions League, La Liga, Serie A, NFL, NHL, UFC og mange andre ligaer.',
    fotball: 'Mål og høydepunkter fra Champions League, La Liga, Serie A, Ligue 1, Eredivisie. Her finner du også sendeskjema i vår TV-guide.',
    ishockey: 'NHL er mer spennende enn noensinne. Se alle høydepunktene til Mats Zuccarello og Andreas Martinsen fra deres karrierer i New York Rangers og Colorado Avalanche.',
    motor: 'Viasat Motor og Viaplay viser Formel 1, MotoGP, Nascar og en rekke andre motorsporter. Her kan du se sendetider, høydepunkter og lese Atle Gulbrandsens tanker om motorsport.',
    nfl: 'NFL-tipping, streaming av NFL-kamper på Viaplay og highlights fra kampene. Her finner du også Viasat NFL Podcast.',
    golf: 'Viasat Golf og Viaplay har rettighetene til å vise en rekke golfturneringer. Se Suzann Pettersen i LPGA, og European Tour med noen av de beste spillerne i verden.',
    kampsport: 'Få med deg hva som skjer rundt Cecilia Brækhus, Conor McGregor og de andre stjernene i bokseverdenen og i UFC.',
  },
  dk: {
    startpage: 'Nyheder, højdepunkter, mål og sammedrag fra dansk og udenlandsk sport. Live-opdatering og video fra de største begivenheder som Champions League, Premiere League, ALKA Superligaen, La Liga, Serie A, NFL, Formel 1 og meget mere.',
    fodbold: 'Mål og højdepunkter fra Champions League, Premiere League, ALKA Superligaen, La Liga, Serie A og andre ligaer.',
    ishockey: 'Ishockey nyheder. Se sammendrag fra alle kampe i NHL. Følg Frederik Andersen, Nikolaj Evers, Jannik Hansen og Frans Nielsen i verdens stærkeste ishockeyliga.',
    motorsport: 'Følg Kevin Magnussens i Formel 1. Se sammendrag og klip fra alle løb.',
    nfl: 'Masser af NFL-aktion. Highlights fra kampe, sammendrag og kommentarer.',
    golf: 'Thorbjørn Olesen, Thomas Bjørn og Rory McIlroy. Få seneste nyt og videoklip fra Ryder Cup, European Tour, og mange af vores andre golf-rettigheder fra Viasat Golf.',
    kampsport: 'Boksning, UFC og MMA. Nyheder og klip med de største stjerner indenfor kampsport.',
  },
  fi: {
    startpage: 'Maalit, kohokohdat, uutiset, haastattelut ja paljon muuta. maailman parhaat liigat, Valioliiga, UEFA Champions League, NHL, KHL, Serie A, La Liga, UFC, NFL ja paljon muuta.',
    jääkiekko: 'NHL ja KHL ja Jokerit. Maalit, koosteet, haastattelut. Seuraa suomalaisia NHL:ssä kuvallisen teksti-tv 235:n avulla.',
    jalkapallo: 'Maalit, kohokohdat ja haastattelut Valioliigasta, Mestarien liigasta, La Ligasta, Serie A:sta ja muista liigoista.',
    golf: 'Golf kohokohdat European Tourilta sekä Major turnauksista.',
    kamppailu: 'UFC kohokohdat. näe Makwan Amirkhani, Teemu Packalén, Conor McGregor ja muut supertähdet ja parhaat palat.',
  },
};

@connect(mapStateToProps)
export default class NewsFeedMeta extends React.PureComponent {
  render() {
    const { country, routeParams } = this.props;

    // Only render when we are on a sports landing page or startpage
    if (_.size(routeParams) > 1) return null;

    const description = descriptions[country][routeParams.sports || 'startpage'];

    const props = _.pickBy({
      meta: [{
        name: 'description',
        content: description,
      }, {
        name: 'og:description',
        content: description,
      }],
      title: formatHeadingText(country, routeParams.sports),
    });

    return (
      <Helmet {...props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/NewsFeed/NewsFeedMeta.jsx